import { resolveGuestCheckoutAssignment } from './ab-assignment';
import type { GuestCheckoutAssignment } from './types';
import type { GuestCheckoutPaymentMode } from './payment-entry';

export function resolveCartPresentationMode(
  assignment: Pick<GuestCheckoutAssignment, 'experimentValue'>,
): GuestCheckoutPaymentMode {
  return assignment.experimentValue === 2 ? 'treatment' : 'control';
}

export function exposeCartViewAssignment() {
  return resolveGuestCheckoutAssignment('cart_view');
}

export function exposeHeaderCartHoverAssignment() {
  return resolveGuestCheckoutAssignment('header_cart_hover');
}
